import React from "react";
import SoftBox from "components/SoftBox";

const ApnaSelect = ({ options, value, name, onChange, origin, required, disabled, className, isCustomHeader,customValue, selectClass, ...rest }) => {
  return (
    <>
      <SoftBox className={className}>
        <>{console.log("rest", rest)
        }</>
        <select
          required={required}
          // className="select Category"
          className={`glassmorphism-card dark-dropdown ${selectClass}`}
          style={{ padding: "10px", width: "100%", borderRadius: "8px" }}
          name={name}
          onChange={onChange}
          value={value}
          disabled={disabled}
          // onBlur={formik.handleBlur}
          {...rest}
        >
          {isCustomHeader ?
            <option value={customValue}>{isCustomHeader}</option> :
            <option value="">Choose {origin}</option>}
          {options && options.length && options.map((elm, i) => {
            return (
              <>
                <option value={elm?._id || elm?.name}>{elm?.name}</option>
              </>
            );
          })}
        </select>
      </SoftBox>
    </>
  );
};

export default ApnaSelect;
